export default "__VITE_ASSET__CH1AoSVf__"